import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useLocation, useParams } from "react-router-dom";
import {Helmet} from "react-helmet";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { MdOutlineArrowLeft, MdOutlineSettingsInputComponent } from "react-icons/md";

import Main from "./Main";
import { AppContext } from "../../Context";
import { Loader, dateToText, FetchAsync, GET, permissions } from "../../inc/Fetch";
import Filter from "../../components/Filter";
import Permission from "../Permission";
import GamesList from './components/GamesList';

import './css/tasks.css'

export default function Site() {

    const { t } = useTranslation();
    const location = useLocation();
    const params = useParams();
    var timer = null;

    const lastPath = location?.pathname?.split("/")?.pop() ;

    const { userData, siteData } = useContext(AppContext); 
    const [site, setsite] = siteData;
    const [userinfo, setuserinfo] = userData;

    const [filterOpen, setfilterOpen] = useState(false);
    const [filter, setfilter] = useState({});
    const [subjects, setsubjects] = useState([]);
    const [selected, setselected] = useState([]);
    // console.log(site); 

    let catID = site?.cats?.filter(r => r?.name == params?.id);
    catID = catID?.length ? catID[0]: false;

    async function loadData() {
        let res = await GET(`games/list?main_cat=${catID?._id || ""}&text=${filter?.text || ""}&classes=${filter?.classes || ""}&subject=${filter?.subject || ""}`);     
        
        return res;
    }
    
    const { data, error, isLoading, refetch } = useQuery(`gamesList`, loadData); 

    function searchForm(e) {
        e.preventDefault();
        refetch();
        setfilterOpen(false);
    }

    if (isLoading) {
        return <Loader />
    }

    
    if (userinfo?.userlevel < 3) {
        return <Permission />
    } else {

        
        let perms = permissions(userinfo, false, catID?._id, "games");
        if (!perms) {
            return <Permission />
        }
        
    }



	return (
		<>
        <Filter Open={filterOpen} setOpen={setfilterOpen}>
            <form onSubmit={searchForm} className='filterFormBox'>
                <div style={{flex:1}}>
                    <label>
                        <span>{t("keywords")}</span>
                        <input type='search' 
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                text:d?.target?.value,
                            }))}
                            value={filter?.text}
                            placeholder={`${t("search")}..`} 
                        />
                    </label>

                    <label>
                        <span>{t("classes")}</span>
                        <select
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                classes:d?.target?.value,
                            }))}
                        >
                            <option value="">--</option>
                            {Object.entries(global.Classes)?.map((v, k) => {

                                return (
                                    <option key={k} value={v[0]}>{t("class")} {v[1]}</option>
                                );

                            })}
                            
                        </select>
                    </label>

                    <label>
                        <span>{t("subject")}</span>

                        <select 
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                subject:d?.target?.value,
                            }))}
                        >
                            <option value="">-{t("filter_all")}-</option>
                            {data?.subjects?.map((v, k) => {
                                return (
                                    <option key={k} value={v?._id}>{v?.name}</option>
                                );
                            })}
                 
                        </select>
                    </label>

                </div>
                <button className='btn'>{t("start_searching")}</button>
            </form>
        </Filter>

        <Main>

            <div style={{ paddingTop:155 }}  className="mainWidth">
                <nav className='breadcrumbs'>
                    <Link to={`/site/${params?.id}`}>{t("home")}</Link>
                    <MdOutlineArrowLeft />
                    <Link>{t("games_title")}</Link>
                
                </nav>
            </div>

            <div className='section4'>

                <div className="mainWidth">
                    
                    <div style={{marginTop:20}} className='mainSectionBox inside'>
                        <div>
                            <h1>{t("games_title")}</h1>
                            <hr />
                        </div>

                        <div style={{display:"flex", gap:5}}>

                            <Link onClick={() => setfilterOpen(r => !r)} title={t("filter")} className='btn openFilter'><MdOutlineSettingsInputComponent /></Link>
                        </div>
 
                    </div>

                    <div className='taskListBox'>
                        
                        {selected?.length ? <div className='sendGamesToStudentBox'>
                            <Link to={`/sendGame`} state={{ previousLocation: location, games: selected }} className='btn'>ارسل الالعاب للطلاب ({selected?.length})</Link>
                        </div>: false}
                        
                        {data?.games?.map((v, k) => {
                            return(
                                <GamesList setselected={setselected} selected={selected} v={v} key={k}/>
                            )
                        })}

                    </div>
                    {!data?.games?.length ? <div style={{color:"#111", textAlign:"center", paddingTop:30}}>{t("error",  { returnObjects: true })[1]}</div>: false}
                </div>
            </div>

         
        </Main>

		</>
	)
}
